module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/001-mauritius-5b8bff5ffaeed4cf8dcaed08fdab6306.svg";